import { Table, IconButton } from '@nimbus-ds/components';
import { EditIcon, TrashIcon } from '@nimbus-ds/icons';
import { GetArTaxRulesResponseDto } from '@tiendanube/common';
import { Stack, CustomHeaderCell } from 'commons/components';
import { useTranslationAccount } from 'domains/Account/hooks';

interface ExceptionsResultDesktopProps {
  data: GetArTaxRulesResponseDto;
  handleEdit: (index: number) => void;
  handleDelete: (index: number) => void;
}

function ExceptionsResultDesktop({
  data,
  handleEdit,
  handleDelete,
}: ExceptionsResultDesktopProps) {
  const t = useTranslationAccount('businessDataPage.taxesWithExceptions.table');

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <CustomHeaderCell>{t('name')}</CustomHeaderCell>
          <CustomHeaderCell width="152px">{t('applyTo')}</CustomHeaderCell>
          <CustomHeaderCell width="104px">{t('taxRate')}</CustomHeaderCell>
          <CustomHeaderCell width="80px">{t('actions')}</CustomHeaderCell>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {data.map(({ id, description, products, iva_rate }, index) => (
          <Table.Row key={id}>
            <Table.Cell as="td">{description}</Table.Cell>
            <Table.Cell as="td">
              {t('quantityProducts', { count: products.length })}
            </Table.Cell>
            <Table.Cell as="td">{iva_rate}%</Table.Cell>
            <Table.Cell as="td">
              <Stack gap="2">
                <IconButton
                  size="2rem"
                  source={<EditIcon />}
                  onClick={() => handleEdit(index)}
                />
                <IconButton
                  size="2rem"
                  source={<TrashIcon />}
                  onClick={() => handleDelete(index)}
                />
              </Stack>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
}

export default ExceptionsResultDesktop;
